var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40.5C8.9543 40.5 0 31.5456 0 20.5C0 9.4543 8.9543 0.5 20 0.5C31.0456 0.5 40 9.4543 40 20.5C40 31.5456 31.0456 40.5 20 40.5ZM17.2438 13.3292C17.1124 13.2416 16.958 13.1948 16.8 13.1948C16.3582 13.1948 16 13.553 16 13.9948V27.0052C16 27.1632 16.0468 27.3176 16.1344 27.449C16.3794 27.8166 16.8762 27.916 17.2438 27.6708L27.0016 21.1656C27.0894 21.107 27.1648 21.0316 27.2234 20.9438C27.4686 20.5762 27.3692 20.0794 27.0016 19.8344L17.2438 13.3292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.dc988127c6d2339b2cff1fd759b9dbdd.svg";
export { ForwardRef as ReactComponent };